import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ShowAllVacationRequests from '../components/VacationsComps/ShowAllVacationRequests';
import VacationMutationModals from '../components/VacationsComps/VacationMutationModals';
import VacationRequestProvider from '../contexts/VacationRequestProvider';

const Vacations = () => {
  // rendering vacations page component here
  return (
    <>
      <PageTitle title='Vacations' />

      <VacationRequestProvider>
        <ShowAllVacationRequests />
        <VacationMutationModals />
      </VacationRequestProvider>
    </>
  );
};

export default Vacations;
